import { useTranslation } from "react-i18next";
import { usePageMeta } from "@/hooks/usePageMeta";

export function NotFound() {
  const { t } = useTranslation();
  usePageMeta({
    title: t("pageMeta.notFoundTitle"),
    robots: "noindex,follow",
  });
  return (
    <section>
      <h1>{t("routes.notFound")}</h1>
    </section>
  );
}
